import type { AppConfig } from '../types';

export const appConfig: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  keycloak: {
    realmUrl: import.meta.env.VITE_KEYCLOAK_REALM_URL || 'http://localhost:8080/realms/master',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'token-server-ui',
  },
};
